var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-frame-area-honobono"},[_c('div',{staticClass:"iframe-wrapper",style:({ height: _vm.height + 'px' })},[_c('iframe',{style:({ height: _vm.height + 'px' }),attrs:{"src":_vm.url}})])])}
var staticRenderFns = []

export { render, staticRenderFns }